export const iconFontAwesomeArrowsArrowRightToBracket = (
	<i className="fa-solid fa-arrow-right-to-bracket"></i>
);
